const Sobre = () => {
  return (
    <main>
      <div className="container">
        <h2 className="title-page">Sobre Doguito</h2>
      </div>
      <section className="container flex flex--center">
        <article className="card">
          El blog de PetShop fue creado para ayudarte con las preguntas más comunes sobre tu mascota.
        </article>
      </section>
    </main>
  )
}

export default Sobre
